import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    // {
    //     field: "testingNo",
    //     headerName: "Testing no",
    //     minWidth: window.innerWidth * 0.08,
    //     flex: 0.8,
    //     filter: true,
    // },
    // {
    //     field: "disAssembleNo",
    //     headerName: "Dis assemble no",
    //     minWidth: window.innerWidth * 0.06,
    //     flex: 0.6,
    //     filter: true,
    // },
    // {
    //     field: "issueNo",
    //     headerName: "Issue no",
    //     minWidth: window.innerWidth * 0.06,
    //     flex: 0.6,
    //     filter: true,
    // },
    {
        field: "drawingNo",
        headerName: "Drawing No",
        minWidth: window.innerWidth * 0.12,
        flex: 1.2,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "size",
        headerName: "Size",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "actualRate",
        headerName: "Actual rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "avlStock",
        headerName: "Avl stock",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "actualRate",
        headerName: "Actual rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "discount",
        headerName: "Discount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "extraCharges",
        headerName: "Extra charges",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "taxableAmt",
        headerName: "Taxable Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "sgstAmt",
        headerName: "SGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.05,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgstAmt",
        headerName: "CGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igstAmt",
        headerName: "IGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "weight",
        headerName: "Weight",
        minWidth: window.innerWidth * 0.05,
        flex: 0.8,
        filter: true,
    },
    {
        field: "natureOfJobWork",
        headerName: "Nature of job work",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "rejQty",
        headerName: "Rej. qty",
        minWidth: window.innerWidth * 0.05,
        flex: 0.8,
        filter: true,
    },
    {
        field: "pendingQty",
        headerName: "Pending qty",
        minWidth: window.innerWidth * 0.05,
        flex: 0.8,
        filter: true,
    },

];

export const MaterialJobWorkPopup = (props) => {
    return (
        <ModalBasic
            id="material-job-work"
            classParams="!w-[85%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Details for material job work</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Job work no</label>
                        <TextInput type='text'
                            id='jobWorkNo' name='jobWorkNo'
                            value={props.materialObject.jobWorkNo}
                            handleChange={(event) => props.handleChangeForWork(event, 'jobWorkNo')}
                            className={props.validState?.error?.jobWorkNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Job work date</label>
                        <TextInput type='date'
                            id='jobWorkDate' name='jobWorkDate'
                            value={props.materialObject.jobWorkDate}
                            handleChange={(event) => props.handleChangeForWork(event, 'jobWorkDate')}
                            className={props.validState?.error?.jobWorkDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Auth. employee</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.employeeList}
                            value={props.materialObject.idEmployee ? props.employeeList.find(x => x.value === props.materialObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.setFilterParametersForWork(event, "idEmployee")
                            }
                            className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                        /> */}
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Testing no</label>
                        <TextInput type='text'
                            id='testingNo' name='testingNo'
                            value={props.materialObject.testingNo}
                            handleChange={(event) => props.handleChangeForWork(event, 'testingNo')}
                            className={props.validState?.error?.testingNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Inv. type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select inv"
                            options={props.invTyleList}
                            value={props.materialObject.idInvType ? props.invTyleList.find(x => x.value === props.materialObject.idInvType) : 0}
                            onChange={(event) =>
                                props.setFilterParametersForWork(event, "idInvType")
                            }
                            className={props.validState?.error?.idInvType !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Job work from</label>
                        <MultiSelectDropdown
                            drpIdentity="Select job work"
                            options={props.jobWorkFromLIst}
                            value={props.materialObject.idJobWorkFrom ? props.jobWorkFromLIst.find(x => x.value === props.materialObject.idJobWorkFrom) : 0}
                            onChange={(event) =>
                                props.setFilterParametersForWork(event, "idJobWorkFrom")
                            }
                            className={props.validState?.error?.idJobWorkFrom !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Reference no</label>
                        <TextInput type='text'
                            id='refNo' name='refNo'
                            value={props.materialObject.refNo}
                            handleChange={(event) => props.handleChangeForWork(event, 'refNo')}
                            className={props.validState?.error?.refNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Inward no</label>
                        <TextInput type='text'
                            id='inwardNo' name='inwardNo'
                            value={props.materialObject.inwardNo}
                            handleChange={(event) => props.handleChangeForWork(event, 'inwardNo')}
                            className={props.validState?.error?.inwardNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Inward date</label>
                        <TextInput type='date'
                            id='inwardDate' name='inwardDate'
                            value={props.materialObject.inwardDate}
                            handleChange={(event) => props.handleChangeForWork(event, 'inwardDate')}
                            className={props.validState?.error?.inwardDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Supplier name</label>
                        <MultiSelectDropdown
                            drpIdentity="Select supplier"
                            options={props.partyAccountList}
                            value={props.materialObject.idVendor ? props.partyAccountList.find(x => x.value === props.materialObject.idVendor) : 0}
                            onChange={(event) =>
                                props.setFilterParametersForWork(event, "idVendor")
                            }
                            className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Inspection</label>
                        <TextInput type='text'
                            id='inspection' name='inspection'
                            value={props.materialObject.inspection}
                            handleChange={(event) => props.handleChangeForWork(event, 'inspection')}
                            className={props.validState?.error?.inspection !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Delivery</label>
                        <TextInput type='text'
                            id='deliveryCommence' name='deliveryCommence'
                            value={props.materialObject.deliveryCommence}
                            handleChange={(event) => props.handleChangeForWork(event, 'deliveryCommence')}
                            className={props.validState?.error?.deliveryCommence !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Process</label>
                        {/* <TextInput type='text'
                            id='process' name='process'
                            value={props.materialObject.process}
                            handleChange={(event) => props.handleChangeForWork(event, 'process')}
                            className={props.validState?.error?.process !== undefined ? "error" : ""}
                        /> */}
                        <MultiSelectDropdown
                            drpIdentity="Select plant"
                            options={props.processList}
                            value={props.materialObject.idProcess ? props.processList.find(x => x.value === props.materialObject.idProcess) : 0}
                            onChange={(event) =>
                                props.setFilterParametersForWork(event, "idProcess")
                            }
                            className={props.validState?.error?.idProcess !== undefined ? "error" : ""}
                            isDisabled={true}
                        />
                    </div>
                    <div className='item-grp grid grid-cols-5 gap-2.5 col-span-5'>
                        <div className='input-grp row-span-2 col-span-2'>
                            <label>Address</label>
                            <textarea rows={4}
                                id='address' name='address'
                                value={props.materialObject.address}
                                onChange={(event) => props.handleChangeForWork(event, 'address')}
                                className={`h-full ${props.validState?.error?.address !== undefined ? "error" : ""}`}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Select plant</label>
                            <MultiSelectDropdown
                                drpIdentity="Select plant"
                                options={props.plantList}
                                value={props.materialObject.idPlant ? props.plantList.find(x => x.value === props.materialObject.idPlant) : 0}
                                onChange={(event) =>
                                    props.setFilterParametersForWork(event, "idPlant")
                                }
                                className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                                isDisabled={true}
                            />
                        </div>

                        <button
                            disabled
                            className="save-btn btns py-[10px] px-[20px] mt-5" onClick={() => props.insert("Insert")}>Add job work process data
                        </button>

                        <div className='input-grp col-span-2'>
                            <label>Account head</label>
                            <MultiSelectDropdown
                                drpIdentity="Select delivery"
                                options={props.accountHeadList}
                                value={props.materialObject.idAccountHead ? props.accountHeadList.find(x => x.value === props.materialObject.idAccountHead) : 0}
                                onChange={(event) =>
                                    props.setFilterParametersForWork(event, "idAccountHead")
                                }
                                className={props.validState?.error?.idAccountHead !== undefined ? "error" : ""}
                            />

                        </div>
                    </div>
                    {props.materialObject.idMaterialJobWork > 0 ?
                        <div className='col-span-3'>
                            <div className='btn-grp flex gap-2.5'>
                                <button
                                    className="save-btn btns py-[10px] px-[20px] " onClick={() => props.downloadMaterialJobWorkInvoice()}>Download Invoice
                                </button>
                                <button
                                    className="save-btn btns py-[10px] px-[20px] " onClick={() => props.downloadPendingMaterialJobWorkInvoice()}>Download Pending Invoice
                                </button>

                                <button
                                    className="save-btn btns py-[10px] px-[20px] " onClick={() => props.shareOnWhatsApp()}>Share On WhatsApp
                                </button>

                                <button
                                    className="save-btn btns py-[10px] px-[20px] " onClick={() => props.sendOnEmail()}>Send Email
                                </button>
                            </div>
                        </div>
                        : null}
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-inner grid grid-cols-6 items-start gap-2.5 mt-2'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChange(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item category</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.types}
                            value={props.itemObject.idType ? props.types.find(x => x.value === props.itemObject.idType) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idType")
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select item"
                            options={props.itemList}
                            value={props.itemObject.idItem ? props.itemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idItem")
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.itemObject.itemIdLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Size</label>
                        <TextInput type='text'
                            id='size' name='size'
                            value={props.itemObject.size}
                            handleChange={(event) => props.handleChange(event, 'size')}
                            className={props.validState?.error?.size !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Actual rate</label>
                        <TextInput type='number'
                            id='actualRate' name='actualRate'
                            value={props.itemObject.actualRate}
                            handleChange={(event) => props.handleChange(event, 'actualRate')}
                            className={props.validState?.error?.actualRate !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Current stock</label>
                        <TextInput type='number'
                            id='avlStock' name='avlStock'
                            value={props.itemObject.avlStock}
                            handleChange={(event) => props.handleChange(event, 'avlStock')}
                            className={props.validState?.error?.avlStock !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChange(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rate</label>
                        <TextInput type='number'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChange(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Amount</label>
                        <TextInput type='number'
                            id='amount' name='amount'
                            value={props.itemObject.amount}
                            handleChange={(event) => props.handleChange(event, 'amount')}
                            className={props.validState?.error?.amount !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Discount (%)</label>
                        <TextInput type='number'
                            id='discount' name='discount'
                            value={props.itemObject.discount}
                            handleChange={(event) => props.handleChange(event, 'discount')}
                            className={props.validState?.error?.discount !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Charges amount</label>
                        <TextInput type='number'
                            id='extraCharges' name='extraCharges'
                            value={props.itemObject.extraCharges}
                            handleChange={(event) => props.handleChange(event, 'extraCharges')}
                            className={props.validState?.error?.extraCharges !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Total</label>
                        <TextInput type='number'
                            id='taxableAmt' name='taxableAmt'
                            value={props.itemObject.taxableAmt}
                            handleChange={(event) => props.handleChange(event, 'taxableAmt')}
                            className={props.validState?.error?.taxableAmt !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Tax group</label>
                        <MultiSelectDropdown
                            drpIdentity="Select tax"
                            options={props.taxStructureList}
                            value={props.itemObject.idTaxGroup ? props.taxStructureList.find(x => x.value === props.itemObject.idTaxGroup) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idTaxGroup")
                            }
                            className={props.validState?.error?.idTaxGroup !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>SGST {props.itemObject.sgst !== '0.00' ? ' - ' + props.itemObject.sgst : ''}</label>
                        <TextInput type='text'
                            id='sgstAmt' name='sgstAmt'
                            value={props.itemObject.sgstAmt}
                            handleChange={(event) => props.handleChange(event, 'sgstAmt')}
                            className={props.validState?.error?.sgstAmt !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>CGST {props.itemObject.cgst !== '0.00' ? ' - ' + props.itemObject.cgst : ''}</label>
                        <TextInput type='text'
                            id='cgstAmt' name='cgstAmt'
                            value={props.itemObject.cgstAmt}
                            handleChange={(event) => props.handleChange(event, 'cgstAmt')}
                            className={props.validState?.error?.cgstAmt !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>IGST {props.itemObject.igst !== '0.00' ? ' - ' + props.itemObject.igst : ''}</label>
                        <TextInput type='text'
                            id='igstAmt' name='igstAmt'
                            value={props.itemObject.igstAmt}
                            handleChange={(event) => props.handleChange(event, 'igstAmt')}
                            className={props.validState?.error?.igstAmt !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Net total</label>
                        <TextInput type='number'
                            id='netTotal' name='netTotal'
                            value={props.itemObject.netTotal}
                            handleChange={(event) => props.handleChange(event, 'netTotal')}
                            className={props.validState?.error?.netTotal !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.itemObject.index !== null ?
                            <>
                                <button
                                    className={`save-btn btns py-[10px] px-[20px] ${props.itemObject.inwardStatus ? "disabled" : ""}`}
                                    onClick={() => props.insertItem("Update")}
                                    disabled={props.itemObject.inwardStatus ? true : false}
                                >
                                    Update
                                </button>
                                <button
                                    className={`delete-btn btns py-[10px] px-[20px] ${props.itemObject.inwardStatus ? "disabled" : ""}`}
                                    disabled={props.itemObject.inwardStatus ? true : false}
                                    onClick={() => props.deleteItem()}>
                                    Delete
                                </button>
                                <button
                                    className="edit-btn btns py-[10px] px-[20px]"
                                    onClick={() => props.clearItem()}>
                                    Clear
                                </button>
                            </>
                            :
                            <>
                                <button
                                    className="save-btn btns py-[10px] px-[20px]"
                                    onClick={() => props.insertItem("Insert")}
                                >
                                    Insert
                                </button>
                                <button
                                    className="edit-btn btns py-[10px] px-[20px]"
                                    onClick={() => props.clearItem()}>
                                    Clear
                                </button>
                            </>
                        }

                    </div>
                </div>
                <div className="process-table h-[30vh] mt-5">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            headerHeight={65}
                            onCellClicked={props.onRowDoubleClickedForSalaryDetails}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                    <span className="text-blue text-[16px] font-semibold">Payment details</span>
                    <div className='input-grp-outer grid grid-cols-7 gap-2.5 mt-2.5'>
                        <div className='input-grp'>
                            <label>Total quantity</label>
                            <TextInput type='number'
                                id='totalQty' name='totalQty'
                                value={props.materialObject.totalQty}
                                handleChange={(event) => props.handleChange(event, 'totalQty')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total amount</label>
                            <TextInput type='number'
                                id='totalAmt' name='totalAmt'
                                value={props.materialObject.totalAmt}
                                handleChange={(event) => props.handleChange(event, 'totalAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Extra charges</label>
                            <TextInput type='number'
                                id='extraCharges' name='extraCharges'
                                value={props.materialObject.extraCharges}
                                handleChange={(event) => props.handleChange(event, 'extraCharges')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Discount amount</label>
                            <TextInput type='number'
                                id='discount' name='discount'
                                value={props.materialObject.discount}
                                handleChange={(event) => props.handleChange(event, 'discount')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Taxable amount</label>
                            <TextInput type='number'
                                id='taxableAmt' name='taxableAmt'
                                value={props.materialObject.taxableAmt}
                                handleChange={(event) => props.handleChangeForPayment(event, 'taxableAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Tax amount</label>
                            <TextInput type='number'
                                id='taxAmt' name='taxAmt'
                                value={props.materialObject.taxAmt}
                                handleChange={(event) => props.handleChange(event, 'taxAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total with tax</label>
                            <TextInput type='number'
                                id='totalwithTax' name='totalwithTax'
                                value={props.materialObject.totalwithTax}
                                handleChange={(event) => props.handleChange(event, 'totalwithTax')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Adjustable amount</label>
                            <TextInput type='number'
                                id='adjustableAmt' name='adjustableAmt'
                                value={props.materialObject.adjustableAmt}
                                handleChange={(event) => props.handleChangeForWork(event, 'adjustableAmt')}
                                className='font-semibold'
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Final amount</label>
                            <TextInput type='number'
                                id='finalAmt' name='finalAmt'
                                value={props.materialObject.finalAmt}
                                handleChange={(event) => props.handleChange(event, 'finalAmt')}
                                className='font-semibold'
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}